<app-banner></app-banner>
<app-smartreading></app-smartreading>
<app-highlightzone></app-highlightzone>
<app-form></app-form>

